module.exports = __webpack_public_path__ + "img/logo1.1aca6c46.png";